import React, { createContext, useContext } from 'react';

const ModalContext = createContext(false);

export const ModalProvider = ({ children }) => (
  <ModalContext.Provider value={true}>{children}</ModalContext.Provider>
);

export const useInModal = () => useContext(ModalContext);

export default ModalContext;
